import { render, staticRenderFns } from "./HomeReview.vue?vue&type=template&id=bbee226e&scoped=true"
import script from "./HomeReview.vue?vue&type=script&lang=js"
export * from "./HomeReview.vue?vue&type=script&lang=js"
import style0 from "./HomeReview.vue?vue&type=style&index=0&id=bbee226e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbee226e",
  null
  
)

export default component.exports